import withInvoiceAppService from "./with-invoice-app-service";

export default withInvoiceAppService;